import helper from '@/libs/forms';
import ENTITY_TYPES from '@/components/entities/resources/newEntityTypes.json';
import US_STATES from '@/components/utils/address/resources/states.json';

const options = {
  type: Object.keys(ENTITY_TYPES).map(key => ({
    id: key,
    name: ENTITY_TYPES[key],
  })),
  partnership: [],
  stateOfIncorporation: US_STATES,
};

const nameField = () => {
  const field = helper.simpleInput(
    'text',
    'Entity Name',
    null,
    'name',
    true,
    6,
  );
  field.maxlength = 100;
  return field;
};


const percentageField = () => {
  const field = helper.simpleInput(
    'number',
    'Specify Percentage:',
    '51.00',
    'partnershipPercentage',
    true,
    12,
    null,
    model =>
      Array.isArray(model.partnership) &&
      model.partnership.includes('llc_owner'),
  );
  field.max = 100;
  field.min = 50.01;
  return field;
};

export default {
  schema: {
    fields: [
      nameField(),
      helper.simpleSelect(
        'State of Incorporation',
        'stateOfIncorporation',
        true,
        options.stateOfIncorporation,
        null,
        6,
      ),
      helper.tax('TIN (Tax ID)', 'tin', null, false, 6),
      helper.simpleSelect('Entity Type', 'type', true, options.type, null, 6),
      helper.date(
        'Date of Filing',
        null,
        'filingDate',
        false,
        6,
        null,
        false,
        true,
      ),
      helper.date(
        'Date of Incorporation',
        null,
        'dateOfIncorporation',
        false,
        6,
        null,
        false,
        true,
      ),
      helper.phone('Phone', 'phone', true, 6),
      helper.boolRadio(
        'Is Guarantor Foreigner?',
        'isPrimaryGuarantorForeignNational',
        true,
        6,
      ),
      helper.simpleInput(
        'text',
        'Nationality',
        'Guarantor Nationality',
        'primaryGuarantorNationality',
        false,
        6,
        null,
        model => model.isPrimaryGuarantorForeignNational,
      ),
      helper.multipleCheckbox(
        'As Guarantor, my relationship to the Borrower (this borrowing entity) is as follows:',
        'partnership',
        [],
        true,
        12,
        '',
        true,
        model => model.type,
      ),
      percentageField(),
    ],
  },
  options: helper.options('new-entity-', true),
  partnershipFieldIndex: 9,
};



// WEBPACK FOOTER //
// ./src/components/entities/schemas/entity.js